import React from 'react';
import Header from '../../Components/Modules/Includes/Header'
import CompanyEdit from './CompanyEdit';
import { connect } from 'react-redux';
import * as actions from '../../Actions/company';

class Company extends React.Component{
		render(){
		return(<div>
					<Header />
					<div className="dashboard-page">
						<div className="right-content-dashboard active-dashboard">
							<CompanyEdit compdata={this.props.currentuser.companydetail} />
						</div>
					</div>
			   </div>
			)
	}
}

const mapStateToProps= (state,props)=> {
    return {
      currentuser : state.login,
    };
}
export default connect(mapStateToProps,actions)(Company);


// WEBPACK FOOTER //
// ./src/Components/Pages/Company.js